// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-wrapper{
    margin-right: 7px;    
}

ul {
    list-style: none;
  }

li{
    margin-bottom: 10px;
}

li a{
    color: #111 !important;
}

@media  (max-width: 768px){
    h2 {       
        font-size: 14px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/homeinformation/homeinformation.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;EAClB;;AAEF;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".icon-wrapper{\r\n    margin-right: 7px;    \r\n}\r\n\r\nul {\r\n    list-style: none;\r\n  }\r\n\r\nli{\r\n    margin-bottom: 10px;\r\n}\r\n\r\nli a{\r\n    color: #111 !important;\r\n}\r\n\r\n@media  (max-width: 768px){\r\n    h2 {       \r\n        font-size: 14px !important;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
